export const DAYS_TO_RECORD_DRUG_SCREEN = 5;
export const MINUTES_TO_RECORD_DRUG_SCREEN_WITHOUT_MODAL = 10;

export const SUPPORTED_APPOINTMENT_TYPES_FOR_AD_HOC_DRUG_SCREEN = ['First Counselor 1:1'];

export const controlLineVisibleAttestationOptions = {
  visible: 'Was visible',
  not_visible: 'Was not visible'
} as const;

export const drugScreensDefaultSearchParams = {
  ordering: '-occurred_at',
  page: '1'
};

export const drugScreenDefaultSortOption = {
  label: 'Newest',
  value: '-occurred_at'
} as const;

export const drugScreenSortOptions = [
  drugScreenDefaultSortOption,
  {
    label: 'Oldest',
    value: 'occurred_at'
  }
];

export const drugScreenTestTypeOrder = {
  self_report: 1,
  urine: 2,
  saliva: 3,
  breath: 4,
  no_test_conducted: 5
} as const;

export const memberInAttendanceOptions = [
  {
    className: 'w-max',
    label: 'Yes, and DID conduct a drug screen or self-report',
    value: 'yes'
  },
  {
    className: 'w-max',
    label: 'Yes, but did NOT conduct a drug screen or self-report',
    value: 'yes_but_no_test'
  },
  {
    className: 'w-max',
    label: 'No',
    value: 'no'
  }
] as const;

export const resultOptions = {
  positive: 'Positive',
  negative: 'Negative',
  invalid: 'Invalid',
  missed: 'Missed',
  formal_positive: 'Formal Positive',
  formal_negative: 'Formal Negative',
  in_progress: 'In Progress',
  abandoned: 'Abandoned'
} as const;

export const temperatureInRangeAttestationOptions = {
  in_range: 'Was within the appropriate range',
  out_of_range: 'Was not within the appropriate range'
} as const;

export const testStripResultOptions = ['Positive', 'Negative', 'Invalid'] as const;
